import { useSelector } from "react-redux";
import CalendarContainer from "../containers/CalendarContainer";

const CalendarPage = () => {
  const { user } = useSelector((state) => state.auth);
  return (
    <div className="content calendar-app">
      <div className="d-flex justify-content-between align-items-center page-title">
        <h1>Calendario</h1>
      </div>
      <CalendarContainer profileId={user?.id} />
    </div>
  );
};

export default CalendarPage;
